import {createAction, props} from '@ngrx/store';
import {Product} from '../models/product';

// helpers
export interface LoadActionPayload {
    productIds: number[];
}

interface LoadSuccessActionPayload extends LoadActionPayload {
    products: Product[];
}

interface LoadFailureActionPayload extends LoadActionPayload {
    error: string;
}

interface MessagePayload {
    product: Product;
    message: string;
}

// actions
export const load = createAction(
    '[Product] Load',
    props<LoadActionPayload>()
);

export const loadSuccess = createAction(
    '[Product] Load success',
    props<LoadSuccessActionPayload>()
);

export const loadFailure = createAction(
    '[Product] Load failure',
    props<LoadFailureActionPayload>()
);

export const actionStart = createAction(
    '[Product] action start',
    props<{ product: Product }>()
);

export const actionSuccess = createAction(
    '[Product] action start success',
    props<MessagePayload>()
);

export const actionError = createAction(
    '[Product] action start error',
    props<MessagePayload>()
);

export const select = createAction(
    '[Product] Select',
    props<{ id: number }>()
);

export const selectProduct = createAction(
    '[Product] Selected product',
    props<Product>()
)
